import { Alert } from 'src/design/atoms/Alert';
import { Avatar } from 'src/design/atoms/Avatar';
import { Loader } from 'src/design/atoms/Loader';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Dropzone } from 'src/design/organisms/Dropzone';
import { IconCloudUp } from '@tabler/icons-react';
import React from 'react';
import { AttachmentDto, FileParameter } from 'src/api/FiretrolApiClient';
import { useUploadTempAttachment } from 'src/api/queries/attachments/useAttachmentMutations';
import { getErrorMessage } from 'src/utils';

interface PostFilesProps {
  onFileUploaded: (file: AttachmentDto) => void;
}

export const PostFileUploader: React.FC<PostFilesProps> = ({
  onFileUploaded,
}) => {
  const uploadAttachment = useUploadTempAttachment('post');
  const { mutate: upload, isPending: loading, error } = uploadAttachment;

  const onDrop = React.useCallback(
    (files: File[]) => {
      const file: FileParameter = {
        data: files[0],
        fileName: files[0].name,
      };
      upload(file, { onSuccess: onFileUploaded });
    },
    [upload, onFileUploaded],
  );

  return (
    <Paper h={215} p="md" withBorder={false}>
      <Dropzone
        onDrop={onDrop}
        maxFiles={1}
        h="100%"
        activateOnClick={false}
        styles={{
          root: {
            borderWidth: 2,
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      >
        <Stack align="center" justify="center" h="100%" gap="xs">
          <Avatar size="lg" color="gray" variant="light">
            {loading ? <Loader size="sm" /> : <IconCloudUp size={24} />}
          </Avatar>
          {loading ? (
            <Text size="md" fw={500}>
              Uploading...
            </Text>
          ) : (
            <>
              <Text size="md" fw={500}>
                Add Files
              </Text>
              <Text size="sm" c="dimmed">
                Or Drag and Drop
              </Text>
            </>
          )}
          {error && (
            <Alert color="red" title="Error">
              {getErrorMessage(error)}
            </Alert>
          )}
        </Stack>
      </Dropzone>
    </Paper>
  );
};
